const userInfo = {
  state: {
    userInfo: null,
    authList: {},
  },
  mutations: {
    setUserInfo(state, val) {
      // console.log('setUserInfo', state, val)
      state.userInfo = val
    },
    setAuth(state, val) {
      state.authList = val
    },
  },
  actions: {},
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    checkAuth: (state) => (code) => {
      return state.authList[code]
    },
    checkAllAuth(state) {
      return state.authList
    },
  },
}
export default userInfo
